import BinaryTreeRangeSetBuilder from "./setBuilder.js";

export class DecorationSet {
  constructor() {
    this.builder = new BinaryTreeRangeSetBuilder();
    this.currentLine = new DecorationLine(this.builder);
  }

  decorate(start, end, decoration) {
    this.currentLine.add(start, end, decoration);
  }

  decorateLine(start, decoration) {
    this.currentLine.nextLine();
    this.builder.add(start, start, decoration);
  }

  decorationsAsArray() {
    this.currentLine.nextLine();
    return this.builder.finish();
  }
}

export class DecorationLine {
  constructor(builder) {
    this.line = [];
    this.builder = builder;
  }

  add(start, end, decoration) {
    this.line.push({from: start, to: end, decoration});
  }

  nextLine() {
    this.line.forEach(({from, to, decoration}) => {
      if (to !== null) {
        this.builder.add(from, to, decoration);
      }
    });
    this.line.length = 0;
  }
}
